import { SegmentProgressIcon } from './SegmentProgressIcon'
import { cn } from '@/lib/utils'

export interface SimulatingProgressCardProps {
  /** 0–100. Drives the segment icon fill and the displayed percentage. */
  percent: number
  /** Main title, e.g. "Simulating your audience" or "Building your audience". */
  title: string
  /** Subtitle line 1, e.g. "Processing your data and preparing your new audience". */
  subtitle?: string
  /** Dismissable hint, e.g. "You can close this tab, we will keep working in the background". */
  dismissHint?: string
  /** Second line: how to resume later from Create audience. */
  resumeHint?: string
  /** Helper line, e.g. "Usually takes 1-2 minutes". */
  helper?: string
  className?: string
}

/**
 * Dark card with segment progress icon, percentage, and copy.
 * Matches Figma "Building your audience" loading design.
 */
export function SimulatingProgressCard({
  percent,
  title,
  subtitle,
  dismissHint,
  resumeHint,
  helper,
  className,
}: SimulatingProgressCardProps) {
  const displayPercent = Math.round(Math.max(0, Math.min(100, percent)))

  return (
    <div
      className={cn(
        'flex flex-col items-center gap-1 rounded-xl bg-card px-6 py-10',
        className,
      )}
    >
      <div className="flex items-center justify-center">
        <SegmentProgressIcon percent={percent} size={82} />
      </div>
      {/* percentage hidden temporarily — value is not precise enough */}
      {/* <p className="text-center font-semibold leading-[1.4] text-primary dark:text-cta text-[20px]">
        {displayPercent}%
      </p> */}
      <h2 className="text-center font-display text-[24px] leading-[1.4] text-card-foreground">
        {title}
      </h2>
      {(subtitle || dismissHint || resumeHint || helper) && (
        <div className="text-center text-[16px] leading-[1.6] text-muted-foreground">
          {subtitle && <p className="mb-0 whitespace-pre-line">{subtitle}</p>}
          {dismissHint && <p className="mb-0">{dismissHint}</p>}
          {resumeHint && <p className="mb-0">{resumeHint}</p>}
          {helper && <p className="mb-0">{helper}</p>}
        </div>
      )}
    </div>
  )
}
